<script>
import axios from '@/utils/axios';

export default {
inject: ['setLoading'],  
  data() {
    return {
     errors: {}, 
     id: '',
     name: '',
     parent_id: '',
     categoryTree: [],
    };
  },
  methods: {
   
   add(){
    this.resetForm();
    this.loadCategoryTree();
   },

   async group(id) {
    this.id = id;
    await this.groupById(id);
    this.loadCategoryTree();
   }, 
   
   async groupById(group_id){
    this.setLoading(true);
    try{
     const response = await axios.get(`/item-groups/${group_id}`);
     const data = response.data.data;
     this.name = data.name;
     this.parent_id = data.parent_id || '';
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false); 
    }
   },

   async loadCategoryTree(){
    try{
     const response = await axios.get(`/item-groups/tree`);
     this.categoryTree = response.data.data; 
    }catch(error){
     console.error('Failed to load.');
    }
   },

   async saveGroup(){
    this.errors = {};
    this.setLoading(true); 

    try{

     const payload = {
      id: this.id,
      name: this.name,
      parent_id: this.parent_id || ''
     }; 

     if(this.id){
      //UPDATE
      const response = await axios.put('/item-groups/update', payload);
      this.$swalToast(response.data.message);
     }else{
      //CREATE
      const response = await axios.post('/item-groups/create', payload);
      this.$swalToast(response.data.message);
     }

     this.$emit('updated'); 
     this.$closeModal('group_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteGroup(){
   this.setLoading(true);
   try{
    const response = await axios.delete(`/item-groups/${this.id}/delete`);
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.$closeModal('delete_modal');
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  }, 

  resetForm() {
   this.id = null;
   this.name = '';
   this.parent_id = '';
   this.errors = {};
  },

  },
};
</script>

<template>
  <!-- Add -->
<div class="modal fade" id="group_modal">
<div class="modal-dialog modal-dialog-centered modal-mg w-100">
<div class="modal-content">
 <div class="modal-header">
  <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} Group</h4>
   <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
    <i class="ti ti-x"></i>
   </button>
  </div>
<form @submit.prevent="saveGroup">
<div class="modal-body pb-0">
<div class="row">

 <div class="col-md-6">
 <div class="mb-3">
  <label class="form-label">Group Name</label>
  <input type="text" class="form-control" v-model="name" />
  <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
 </div>
 </div>
 
 <div class="col-md-6">
 <div class="mb-3">
  <label class="form-label">Parent</label>
  <select class="form-control" v-model="parent_id">
   <option value="">No Parent (Top Level)</option>
   <option v-for="cat in categoryTree" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
  </select>
  <div v-if="errors.parent_id" class="text-danger small mt-1">{{ errors.parent_id[0] }}</div>
 </div>
 </div>

</div>
</div>

 <div class="modal-footer">
  <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
  <button type="submit" class="btn btn-primary">Save</button>
 </div>
</form>
</div>
</div>
</div>
  <!-- /Add -->

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete the item, this cant be undone once you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteGroup">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>
